import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_HOME_WORKS_URL,
  GET_HOME_WORK_URL,
  SUBMIT_HOME_WORK_URL,
  GET_COMPLETED_HOME_WORK_URL,
} from "../apiurls/apiurls";

export const getHomeworks = async (filter) => {
  try {
    const response = await axiosInstance.get(GET_HOME_WORKS_URL, {
      params: { filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching homeworks:", error);
    throw error;
  }
};

export const getHomeworkById = async (id, level) => {
  try {
    const response = await axiosInstance.get(GET_HOME_WORK_URL, {
      params: { id, level },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching homework by id:", error);
    throw error;
  }
};

export const submitHomework = async (id, level, payload) => {
  try {
    const response = await axiosInstance.post(SUBMIT_HOME_WORK_URL, payload, {
      params: { id, level },
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting homework:", error);
    throw error;
  }
};

export const getCompletedHomework = async (id, level) => {
  try {
    const response = await axiosInstance.get(GET_COMPLETED_HOME_WORK_URL, {
      params: { id, level },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching completed homework:", error);
    throw error;
  }
};
